import { useApi } from '@omnipresentgroup/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  API_BASE,
  API_PATH,
  INVOICE_REPORT_APPROVE_API_PATH,
} from '../constants';

export const useApproveInvoiceReportMutation = () => {
  const { POST } = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      companyId,
      invoiceId,
    }: {
      companyId: string;
      invoiceId: string;
    }) => {
      return POST({
        path: `${API_BASE}/${INVOICE_REPORT_APPROVE_API_PATH(companyId, invoiceId)}`,
        body: {},
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [API_PATH],
      });
    },
  });
};
